import ITab, { TabValues } from "interfaces/Tab";
import routes from "common/routes";

export const TRAINER_HORSE_GET_OPTIONS = [
  "id",
  "stallNumber",
  "barn.name",
  "currentFacility.name",
  "currentFacility.code",
  "currentFacility.workout_required_days_off",
  "currentFacility.region.id",
  "currentFacility.backgroundColor",
  "currentFacility.foregroundColor",
  "currentFacility.strokeColor",
  "chip_number",
  "barn.facility.name",
  "barn.facility.code",
  "barn.facility.foregroundColor",
  "birthday",
  "dam_name",
  "last_race_date",
  "last_race_facility.code",
  "last_race_facility.name",
  "last_workout_date",
  "last_workout_facility.code",
  "last_workout_facility.name",
  "last_exam_date",
  "name",
  "breeder.name",
  "owner.first_name",
  "owner.last_name",
  "registration_number",
  "sire_name",
  "registration_number",
  "registration_status",
  "breed_type",
  "gender",
  "certificate_issued_date",
  "breeding_year",
  "color_description",
  "trainer.first_name",
  "trainer.last_name",
  "trainer.trainerNumber",
  "trainer.type",
  "stateEligibleCode",
  "dateOfDeath",
  "lifetime.starts",
  "lifetime.wins",
  "lifetime.place",
  "lifetime.show"
];

export const trainerTabsList: ITab[] = [
  { name: "Details", value: TabValues.DETAILS, path: routes.horseDetails.path },
  {
    name: "Activity",
    value: TabValues.ACTIVITY,
    path: routes.horseDetailsActivity.path
  },
  {
    name: "Comments",
    value: TabValues.COMMENTS,
    path: routes.horseDetailsComments.path
  }
];
